<div
  class="kl-field"
  [class.kl-field--my-3]="marginY()"
  [class.kl-field--mb-2]="marginBottom()"
  [formGroup]="formGroup()">
  @if (label()) {
    <kl-label
      [label]="label()"
      [labelDescription]="labelDescription()"
      [isRequired]="required()"
      [htmlFor]="fieldId()" />
  }

  <div #fieldControl class="kl-field__control text-start">
    @if (bindWholeObject()) {
      <p-multiselect
        [inputId]="fieldId()"
        [options]="options()"
        [optionLabel]="optionLabel()"
        [dataKey]="dataKey() ?? 'id'"
        [display]="display()"
        [placeholder]="placeholder() | translate"
        [filter]="filter()"
        [showClear]="showClear()"
        [appendTo]="appendTo()"
        [panelStyle]="matchPanelToTriggerWidth() ? panelOverlayStyle() : null"
        panelStyleClass="kl-multiselect-overlay-panel"
        [formControlName]="controlName()"
        [fluid]="fluid()"
        [maxSelectedLabels]="maxSelectedLabels()"
        [selectedItemsLabel]="selectedItemsLabel() ? (selectedItemsLabel()! | translate) : undefined"
        [invalid]="showInvalid()"
        (onPanelShow)="onMultiselectPanelShow()"
        (onPanelHide)="onMultiselectPanelHide()"
        (onChange)="onAnyChange()" />
    } @else {
      <p-multiselect
        [inputId]="fieldId()"
        [options]="options()"
        [optionLabel]="optionLabel()"
        [optionValue]="optionValue()"
        [display]="display()"
        [placeholder]="placeholder() | translate"
        [filter]="filter()"
        [showClear]="showClear()"
        [appendTo]="appendTo()"
        [panelStyle]="matchPanelToTriggerWidth() ? panelOverlayStyle() : null"
        panelStyleClass="kl-multiselect-overlay-panel"
        [formControlName]="controlName()"
        [fluid]="fluid()"
        [maxSelectedLabels]="maxSelectedLabels()"
        [selectedItemsLabel]="selectedItemsLabel() ? (selectedItemsLabel()! | translate) : undefined"
        [invalid]="showInvalid()"
        (onPanelShow)="onMultiselectPanelShow()"
        (onPanelHide)="onMultiselectPanelHide()"
        (onChange)="onAnyChange()" />
    }
  </div>

  <div class="kl-field__error text-start">
    @if (showFieldError() && controlError()) {
      <span>{{ controlError() }}</span>
    }
  </div>
</div>
